import API from 'services/API';

export default function createRelations(data) {
  return API.request({
    method: 'POST',
    url: '/guardianship/create',
    data,
  });
}
